import { UserLoginHistory } from '@monorepo/shared-lib';
import type { LoginDetails } from 'store/user/models';

interface HistoryProps {
  history?: LoginDetails[];
  onClose: () => void;
  profileMode?: boolean;
  loading?: boolean;
}

export const History = (props: HistoryProps) => <UserLoginHistory {...props} />;
